import {
  Component,
  OnInit
} from '@angular/core';
import {
  UserApiService
} from 'src/app/user-api.service';
import {
  UserApi
} from 'src/app/models/api_models/user';
import {
  BookService
} from 'src/app/api/book.service';
import {
  BookResult
} from 'src/app/models/api_models/book';

import {MatDialog, MAT_DIALOG_DATA} from '@angular/material/dialog';
import * as L from 'leaflet';
import { LeafletMapStationZoomComponent } from 'src/app/leaflet/leaflet-map-station-zoom/leaflet-map-station-zoom.component';

@Component({
  selector: 'app-user-dashboard',
  templateUrl: './user-dashboard.component.html',
  styleUrls: ['./user-dashboard.component.scss']
})
export class UserDashboardComponent implements OnInit {


  private _currentUser: UserApi = null;
  get currentUser() : UserApi {return this._currentUser;}
  set currentUser(currentUser : UserApi) {this._currentUser = currentUser;}

  private _bookList: BookResult[] = null;
  get bookList() : BookResult[] {return this._bookList;}
  set bookList(bookList : BookResult[]) {this._bookList = bookList;}

  private _bookListError: string = null;
  get bookListError() : string {return this._bookListError;}
  set bookListError(bookListError : string) {this._bookListError = bookListError;}

  private _nextResa: BookResult = undefined;
  get nextResa() : BookResult {return this._nextResa;}
  set nextResa(nextResa : BookResult) {this._nextResa = nextResa;}

  private _currentType: number = 1;
  get currentType() : number {return this._currentType;}
  set currentType(currentType : number) { this._currentType = currentType}

  private _loading_Resa: boolean = true;
  get loading_Resa() :boolean {return this._loading_Resa;}
  set loading_Resa(loading_Resa:boolean) {this._loading_Resa = loading_Resa;}

  private _nextBookTitle : string =  "Votre prochaine réservation";
  get nextBookTitle() : string {return this._nextBookTitle;}
  set nextBookTitle(nextBookTitle : string) {this._nextBookTitle = nextBookTitle;}

  private _today : Date = new Date();
  get today() : Date {return this._today;}
  set today(today : Date ) {this._today = today;}
  
  private _servicesList = [];
  get servicesList() {return this._servicesList;}
  set servicesList(servicesList) {this._servicesList = servicesList}

  constructor(public dialog: MatDialog, private userService: UserApiService, private bookService: BookService) {}

  getUser() {
    this.userService.getCurrentUserData().subscribe(
      response => {
        // console.log(response);
        this._currentUser = response;
        this._servicesList = this._currentUser.getUserServices();
      }
    )
  }

  displayLeafletDialog(stationId) {
    this.dialog.open(LeafletMapStationZoomComponent, {
      data: null,
    });
  }

  getBookList() {
    this.bookService.getBooks().subscribe(
      response => {
        if (response != null) {
          this._bookList = response;
          let currentDate = new Date();
          // console.log(response);
          for (let book of this._bookList) {
            let bookDateDeparture = new Date(book.startdate.replace("Z", ""));
            let bookDateArrival = new Date(book.enddate.replace("Z", ""));
            
            if (currentDate.getTime() > bookDateDeparture.getTime()) {
              if (currentDate.getTime() <= bookDateArrival.getTime() &&
                book.status == "reserved" &&
                book.type == this._currentType) {
                  this._nextResa = book;
                  this._nextBookTitle = "Votre reservation en cours";
              }
              break;
            }
            if (book.status == "reserved" && book.type == this._currentType) {
              this._nextResa = book;
              break;
            }
          }
        }
      },
      error => {
        this._bookListError = "Oops une erreur est survenue"
      }
    )
  }

  ngOnInit() {
    this.getUser();
    this.getBookList();
  }

}

// @Component({
//   selector: 'dialog-content-example-dialog',
//   template: '<h1>OK</h1>',
// })
// export class DialogContentExampleDialog {}